import { Component, Inject, Optional } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BrowserStorage } from '../../../../utils/shared-services/browser-storage.service';
import { CaptionService } from '../../../../utils/shared-services/caption.service';
import { WidgetDescriptionDialog } from '../../../../features/store-portal/components/dialogs/widget-description-dialog.component';

@Component({
    selector: 'hoWid010',
    templateUrl: 'src/app/features/head-office-portal/widgets/templates/wid-010.html',
    standalone: false
})
export class HoWid010 {
    public captions: any;
    public isTimedOut: boolean = false;

    public msgValue: string;
    
    constructor(
        @Inject(Object) @Optional() private widget: any,
        @Inject(CaptionService) private captionService,
        @Inject(BrowserStorage) private browserStorage: BrowserStorage,
        @Inject(MatDialog) private dialog: MatDialog
    ) {
        this.captions = this.captionService.captions;
    }

    openInfoDialog() {
        this.dialog.open(WidgetDescriptionDialog, {
            panelClass: 'app-full-bleed-dialog',
            maxWidth: '95vw',
            data: {
                widgetID: 'ho-' + this.widget.id,
            },
        });
    }

    ngOnInit() {
        // to change animation on wid-000
        if (this.widget && this.widget.isTimedOut) {
            this.isTimedOut = true;
            return;
        }

        if (!this.widget || !this.widget.isLoaded) {
            return;
        }

        let portalData = this.browserStorage.getSessionstorage('hoPortalData', null);
        let data = JSON.parse(JSON.stringify(portalData));
        let config = JSON.parse(data.WidgetValueConfig);
        this.msgValue = config?.message ? config.message : ' ';
    }
}
